import routerHistory from 'routes/history';

const hlink = (link: string, history = routerHistory) => (e: any) => {
  e.preventDefault();
  history.push(link);
};

export default hlink;
